'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconNewspaper = function IconNewspaper(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement(
      'g',
      { fill: color, transform: 'translate(3 5)' },
      _react2.default.createElement('path', { d: 'm17.5955056 0h-13.93665167c-.22348314 0-.42289887.18121348-.42289887.40449438v12.14191012c0 .665191-.52280899 1.2064045-1.188 1.2064045h-.0325618c-.66519101 0-1.2064045-.5412135-1.2064045-1.2064045v-10.52393259c0-.2232809-.18121348-.40449438-.40449438-.40449438s-.40449438.18121348-.40449438.40449438v10.52393259c0 1.1113483.90404494 2.0153933 2.01539326 2.0153933h.0325618c.04105618 0 .08170786-.0012135.1221573-.0036405.01779775.002427.036.0036405.05460674.0036405h13.752809c1.115191 0 2.0224719-.904045 2.0224719-2.0153933v-12.14191012c0-.2232809-.1812135-.40449438-.4044944-.40449438zm-.4044944 12.5464045c0 .665191-.5442472 1.2064045-1.2134831 1.2064045h-12.31604495c.25220224-.3365393.38346067-.7541798.38346067-1.2064045v-11.73741574h13.14606738z' }),
      ' ',
      _react2.default.createElement('path', { d: 'm1.61797753 1.21348315v11.12359555c0 .2232809.18121348.4044943.40449438.4044943s.40449438-.1812134.40449438-.4044943v-11.12359555c0-.2232809-.18121348-.40449439-.40449438-.40449439s-.40449438.18121349-.40449438.40449439z' }),
      ' ',
      _react2.default.createElement('path', { d: 'm5.66292135 7.68539326h9.91011235c.2232809 0 .4044944-.18121348.4044944-.40449438v-3.23595506c0-.2232809-.1812135-.40449438-.4044944-.40449438h-9.91011235c-.2232809 0-.40449438.18121348-.40449438.40449438v3.23595506c0 .2232809.18121348.40449438.40449438.40449438zm.40449438-3.23595506h9.10112357v2.42696629h-9.10112357z' }),
      ' ',
      _react2.default.createElement('path', { d: 'm5.66292135 9.30337079h4.04494382c.2232809 0 .40449443-.18121349.40449443-.40449439 0-.22328089-.18121353-.40449438-.40449443-.40449438h-4.04494382c-.2232809 0-.40449438.18121349-.40449438.40449438 0 .2232809.18121348.40449439.40449438.40449439z' }),
      ' ',
      _react2.default.createElement('path', { d: 'm5.66292135 2.83146067h9.91011235c.2232809 0 .4044944-.18121348.4044944-.40449438s-.1812135-.40449438-.4044944-.40449438h-9.91011235c-.2232809 0-.40449438.18121348-.40449438.40449438s.18121348.40449438.40449438.40449438z' }),
      ' ',
      _react2.default.createElement('path', { d: 'm5.66292135 10.9213483h4.04494382c.2232809 0 .40449443-.1812135.40449443-.4044944s-.18121353-.4044943-.40449443-.4044943h-4.04494382c-.2232809 0-.40449438.1812134-.40449438.4044943s.18121348.4044944.40449438.4044944z' }),
      ' ',
      _react2.default.createElement('path', { d: 'm5.66292135 12.5393258h3.03370786c.2232809 0 .40449439-.1812134.40449439-.4044943s-.18121349-.4044944-.40449439-.4044944h-3.03370786c-.2232809 0-.40449438.1812135-.40449438.4044944s.18121348.4044943.40449438.4044943z' }),
      ' ',
      _react2.default.createElement('path', { d: 'm15.3707865 8.49438202h-4.0449438c-.2232809 0-.4044944.18121349-.4044944.40449438 0 .2232809.1812135.40449439.4044944.40449439h4.0449438c.2232809 0 .4044944-.18121349.4044944-.40449439 0-.22328089-.1812135-.40449438-.4044944-.40449438z' }),
      ' ',
      _react2.default.createElement('path', { d: 'm15.3707865 10.1123596h-4.0449438c-.2232809 0-.4044944.1812134-.4044944.4044943s.1812135.4044944.4044944.4044944h4.0449438c.2232809 0 .4044944-.1812135.4044944-.4044944s-.1812135-.4044943-.4044944-.4044943z' }),
      ' ',
      _react2.default.createElement('path', { d: 'm14.3595506 11.7303371h-3.0337079c-.2232809 0-.4044944.1812135-.4044944.4044944s.1812135.4044943.4044944.4044943h3.0337079c.2232809 0 .4044943-.1812134.4044943-.4044943s-.1812134-.4044944-.4044943-.4044944z' }),
      ' '
    )
  );
};

IconNewspaper.propTypes = {
  color: _propTypes2.default.string
};

IconNewspaper.defaultProps = {
  color: _colors2.default.icons
};

IconNewspaper.displayName = 'IconNewspaper';

exports.default = IconNewspaper;
module.exports = exports.default;